import { isNumber } from 'lodash-es';
import isNil from 'lodash-es/isNil';
import reduceRight from 'lodash-es/reduceRight';
import { isLastValuesAggregation } from '../../enums/Aggregations';
import { isFrost, isHydricStress } from '../../enums/MetricIds';
import { isHydricDeficitTuple, isHydricStressTuple } from '../../resources/measurements.type';
import { availableConverters } from '../units/converters';
const extractFrostLastValuesFromSummaryData = ({ lastValues, universeAggregate }) => {
    let value = null;
    let timestamp = null;
    if (isNil(lastValues) || isNil(universeAggregate)) {
        return {
            value,
            timestamp
        };
    }
    else {
        const frostValues = [
            { value: null, timestamp: null },
            { value: null, timestamp: null },
            { value: null, timestamp: null }
        ];
        let idx = 0;
        reduceRight(lastValues, (acc, frostValue) => {
            ;
            [timestamp, value] = Object.entries(frostValue)[0];
            acc[idx] = { timestamp, value };
            idx++;
            return acc;
        }, frostValues);
        if (universeAggregate === 'n-2-measure') {
            return frostValues[2];
        }
        else if (universeAggregate === 'n-1-measure') {
            return frostValues[1];
        }
        else if (universeAggregate === 'real-time') {
            return frostValues[0];
        }
        return {
            value,
            timestamp
        };
    }
};
export const extractValueFromSummaryData = ({ data, metricId, aggregate, universeAggregate, horizon }) => {
    const valueKey = `${metricId}_${aggregate}`;
    const timestampKey = `${valueKey}i`;
    const aggregateValue = data[valueKey];
    const timestampValueTemp = data[timestampKey];
    const timestampValue = typeof timestampValueTemp === 'object' ? undefined : timestampValueTemp;
    let result = undefined;
    if (isHydricStress(metricId)) {
        if (metricId === 'U_CAPA') {
            if (!isNil(aggregateValue) && isHydricStressTuple(aggregateValue)) {
                const timestamp = data.U_CAPA_Li;
                result = {
                    value: aggregateValue[0],
                    timestamp: isNil(timestamp) ? null : timestamp,
                    threshold: aggregateValue[1],
                    trend: aggregateValue[2]
                };
            }
        }
        else if (metricId === 'HPOT') {
            if (!isNil(aggregateValue) &&
                !isNil(horizon) &&
                !Array.isArray(aggregateValue) &&
                typeof aggregateValue !== 'number') {
                const value = aggregateValue[horizon];
                const timestamp = data.HPOT_Li?.[horizon];
                if (!isNil(value) && typeof value !== 'string') {
                    result = {
                        value: value[0],
                        timestamp: isNil(timestamp) ? null : timestamp,
                        threshold: value[1],
                        trend: value[2]
                    };
                }
            }
        }
        if (result === undefined) {
            result = { value: null, timestamp: isNil(timestampValue) ? null : timestampValue };
        }
    }
    else if (isNil(aggregateValue)) {
        result = { value: null, timestamp: isNil(timestampValue) ? null : timestampValue };
    }
    else if (metricId === 'HDEF') {
        if (!isNil(aggregateValue) && isHydricDeficitTuple(aggregateValue)) {
            const timestamp = data?.HDEF_Di;
            result = {
                value: aggregateValue[0],
                timestamp: isNil(timestamp) ? null : timestamp,
                threshold: aggregateValue[1]
            };
        }
        if (result === undefined) {
            result = { value: null, timestamp: isNil(timestampValue) ? null : timestampValue };
        }
    }
    else if (metricId === 'LW_V') {
        result = {
            value: isNumber(aggregateValue) ? aggregateValue : null,
            timestamp: isNil(timestampValue) ? null : timestampValue
        };
    }
    else if (metricId === 'LW_D') {
        const converter = availableConverters['time'];
        result = {
            value: isNumber(aggregateValue) ? converter(aggregateValue, 'hours') : null,
            timestamp: isNil(timestampValue) ? null : timestampValue
        };
    }
    else if (isLastValuesAggregation(aggregate) && isFrost(metricId)) {
        if (Array.isArray(aggregateValue) &&
            !isHydricStressTuple(aggregateValue) &&
            !isHydricDeficitTuple(aggregateValue)) {
            result = extractFrostLastValuesFromSummaryData({
                lastValues: aggregateValue,
                universeAggregate
            });
        }
        else {
            throw new Error(`this value should be an array ${aggregateValue} ${data} ${valueKey}`);
        }
    }
    else {
        if (Array.isArray(aggregateValue)) {
            throw new Error(`this value should not be an array ${aggregateValue} ${data} ${valueKey}`);
        }
        if (typeof aggregateValue !== 'number') {
            throw new Error('invalid');
        }
        result = {
            value: isNil(aggregateValue) ? null : aggregateValue,
            timestamp: isNil(timestampValue) ? null : timestampValue
        };
    }
    return result;
};
